import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { post, get } from "@utils/axios_api";
import { useQuery } from "@tanstack/react-query";
import { downloadExcel } from "@utils/downloadExcel";

const schema = yup.object().shape({
    file: yup
      .mixed()
      .test("required", "엑셀 파일을 선택해주세요.", (value) => {
        return value && value.length > 0; 
      }),
    bizRegNo: yup
      .string()
      .required("소속 업체를 선택해주세요.")
      .notOneOf([""], "소속 업체를 선택해주세요."),
  });

export function useMemberExcelRegist() {
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: { file: null, bizRegNo: "" },
    shouldFocusError: false,
  });

  const { handleSubmit, watch  } = methods;
  const [previewData, setPreviewData] = useState([]);

    const { data:companyList } = useQuery({
      queryKey: ["adminSearchCompanyList"],
      queryFn: async () => {
        const response = await get("/admin/mem/companyList");
        return response;
      },
    });

  // 샘플 다운로드 기능
  const handleSampleDownload = (e) => {
    e.preventDefault();
    downloadExcel({
      url: "/admin/mem/sampleExcelDown",
      filePrefix: "회원등록 샘플양식",
    });

  }

  // 미리보기 API 호출
  const previewUpload = async (formData) => {
    try {
      const response = await post("/admin/mem/uploadExcel", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
        setPreviewData(response.result);
    } catch (error) {
      console.error("미리보기 API 오류:", error);
    }
  };

  const onSubmit = async (data) => {
    const fileList = data.file;
    if (!fileList || fileList.length === 0) {
      alert("업로드할 파일을 선택해주세요.");
      return;
    }
    const file = fileList[0];
    const formData = new FormData();

    formData.append("file", file);
    formData.append("bizRegNo", data.bizRegNo);

    await previewUpload(formData);
  };

  // 미리보기 후 등록 처리 (confirm 포함)
  const saveData = async () => {

    const bizRegNo = watch("bizRegNo");

    if (previewData.length === 0) {
      alert("먼저 미리보기 후 등록할 데이터를 확인해주세요.");
      return;
    }

    if (!window.confirm("등록하시겠습니까?")) return;

    try {
      const payload = { previewData, bizRegNo };
      const response = await post("/admin/mem/memberAllSave", payload);

      if (response.status !== false) {
        alert(response.message || "등록 성공");
        window.location.reload();
      }
    } catch (error) {
      console.error("등록 API 오류:", error);
      const serverData = error.response?.data;
      if (serverData  && serverData.errorCode === "DUPLICATE_EMAIL") {
        alert(serverData.message || "중복된 이메일이 있습니다.");
        return;
      } else {
        alert("등록 실패하였습니다.");
      }
    }
  };



  return {
    methods,
    handleFormSubmit: handleSubmit(onSubmit),
    previewData,
    saveData,
    setPreviewData,
    handleSampleDownload,
    companyList,
  };
}


